import React from "react";

const HonorsInfo = (props) => {
  return (
    <div className="card">
      <h3>Academic Honors</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.academicHonorOne && (
          <div class="datas">
            <p>Academic Honor One:</p>
            <del>{props.data?.uncommonOldData?.academicHonorOne}</del>
            <span>{props.data?.uncommonNewData?.academicHonorOne}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorTwo && (
          <div class="datas">
            <p>Academic Honor Two:</p>
            <del>{props.data?.uncommonOldData?.academicHonorTwo}</del>
            <span>{props.data?.uncommonNewData?.academicHonorTwo}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorThree && (
          <div class="datas">
            <p>Academic Honor Three:</p>
            <del>{props.data?.uncommonOldData?.academicHonorThree}</del>
            <span>{props.data?.uncommonNewData?.academicHonorThree}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorFour && (
          <div class="datas">
            <p>Academic Honor Four:</p>
            <del>{props.data?.uncommonOldData?.academicHonorFour}</del>
            <span>{props.data?.uncommonNewData?.academicHonorFour}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorFive && (
          <div class="datas">
            <p>Academic Honor Five:</p>
            <del>{props.data?.uncommonOldData?.academicHonorFive}</del>
            <span>{props.data?.uncommonNewData?.academicHonorFive}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorSix && (
          <div class="datas">
            <p>Academic Honor Six:</p>
            <del>{props.data?.uncommonOldData?.academicHonorSix}</del>
            <span>{props.data?.uncommonNewData?.academicHonorSix}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorSeven && (
          <div class="datas">
            <p>Academic Honor Seven:</p>
            <del>{props.data?.uncommonOldData?.academicHonorSeven}</del>
            <span>{props.data?.uncommonNewData?.academicHonorSeven}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorEight && (
          <div class="datas">
            <p>Academic Honor Eight:</p>
            <del>{props.data?.uncommonOldData?.academicHonorEight}</del>
            <span>{props.data?.uncommonNewData?.academicHonorEight}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorNine && (
          <div class="datas">
            <p>Academic Honor Nine:</p>
            <del>{props.data?.uncommonOldData?.academicHonorNine}</del>
            <span>{props.data?.uncommonNewData?.academicHonorNine}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.academicHonorTen && (
          <div class="datas">
            <p>Academic Honor Ten:</p>
            <del>{props.data?.uncommonOldData?.academicHonorTen}</del>
            <span>{props.data?.uncommonNewData?.academicHonorTen}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default HonorsInfo;
